import React from 'react';

import groupBy from 'lodash/groupBy';

import Activity from './activity';
import { formatDate, MONTH_DAY_YEAR_FORMAT } from 'helpers/formatters/date_time_formats';

import type { Activity as ActivityProps } from './types';
import type { Parent } from 'bundles/crm/types';

interface Props {
  activities: ActivityProps[];
  currentParent?: Parent | Parent[];
  forUserId?: number;
  isBackofficeAdmin?: boolean;
  options?: object;
  showParents?: boolean | 'path';
  tagText?: string;
  onDelete: (activity: ActivityProps) => void;
  onSave: (activity: ActivityProps) => void;
}


export default function ActivityList({ activities, showParents, ...props }: Props) {
  const activitiesByHeader = groupBy(activities, activity => formatDate(activity.date, MONTH_DAY_YEAR_FORMAT));

  return <>
    {Object.keys(activitiesByHeader).map(header => (
      <div key={header}>
        <div className="d-flex align-items-center">
          <h4 className="my-3 mr-2">
            <b>{header}</b>
          </h4>
          <hr className="m-0 flex-grow-1" />
        </div>

        {activitiesByHeader[header].map(activity => (
          <Activity {...props} activity={activity} key={activity.id} showParent={showParents} />
        ))}
      </div>
    ))}
  </>;
}